import { render, staticRenderFns } from "./Psychologists.vue?vue&type=template&id=a6265bce&scoped=true&"
import script from "./Psychologists.vue?vue&type=script&lang=js&"
export * from "./Psychologists.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6265bce",
  null
  
)

export default component.exports